module.exports = require("properties");